export default __webpack_public_path__ + "static/media/lava-ui-lg-1.5a275cd7.webp";